import moment from 'moment';
import { ITreeParams } from '@/store/materials/nav/types';

// 拼接导航名称
export function navName(payload: ITreeParams) {
  const name = payload.entityType;
  const code = payload.orgCode ? `_${payload.orgCode}` : '';
  const time = (payload.timestamp && payload.timestamp !== 0) ? `_${payload.timestamp}` : '';
  return name + code + time;
}

// 将过滤项构建为`可递归`的树结构
// 返回的结果可以看作是一个 filterOptions 数组, 一般配合 cateTreeBuild() 使用
export function filterListBuild(filterList: any[]) {
  return filterList.map((filterItem) => {
    const { options, ...rest } = filterItem;
    return { ...rest, filterItem, filterItemCode: rest.code };
  });
}

// 重建导航版本列表
export function versionListBuild(list: string[]) {
  return (list || []).map((item, index) => {
    const strList = item.split('_');
    const entity = strList[0] || '';
    const ts = strList.slice(-1)[0] || '';
    const timestamp = parseInt(ts, 10) || 0;
    const date = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
    const nameWithoutTime = strList.slice(0, -1).join('_');
    return { id: index, name: item, navName: nameWithoutTime, timestamp, date, entity };
  });
}

// 重建导航树(增加 prevId, nextId, deep, path 等字段)
export function navTreeBuild(list: any[], path: any[], deep = 1): any[] {
  return (list || []).reduce((acc, cur, i, arr) => {
    const { navigationDtoList, ...rest } = cur;
    const prevId = arr[i - 1]?.id;
    const nextId = arr[i + 1]?.id;
    const curPath = [...path, rest];
    const children = navTreeBuild(navigationDtoList, curPath, deep + 1);
    const baseItem = { ...rest, prevId, nextId, deep, path: curPath };
    const item = children.length ? { ...baseItem, children } : baseItem;
    return [...acc, item];
  }, []);
}

// 重建分类树(增加 deep, path 等字段)
// 将过滤项按 options 字段进行递归，并构建为树形结构
export function cateTreeBuild(filterOptions: any[], pathList: any[], deep = 1): any[] {
  return filterOptions.reduce((acc, cur) => {
    const { filterItem, ...rest } = cur;
    const path = [...pathList, rest];
    const children = cateTreeBuild(filterItem?.options || [], path, deep + 1);
    const baseItem = { ...rest, deep, path };
    const item = children.length ? { ...baseItem, children } : baseItem;
    return [...acc, item];
  }, []);
}

// 重建标签列表(添加 '不限' 选项, 及其他字段)
export function labelListBuild(filterList: any[]) {
  return (filterList || []).map((item) => {
    const { code, name, itemType, entityType, options = [], ...rest } = item;
    const opts = [{ id: -1, code: '', name: '不限',  entityType: '' }, ...options].map((opt) => {
      return { ...opt, itemType, entityType, filterItemCode: code, filterItemName: name };
    });
    return { ...rest, code, name, itemType, entityType, options: opts };
  });
}

// 重建颜色列表(添加数据字段)
export function colorListBuild(list: any[]) {
  const lastColorList = (list.slice(-1)[0]?.color_list || []) as any[];
  const normal = list.slice(0, -1).map((item, i) => {
    const color = item.color.hex;
    const name = `${i + 1}号`;
    const dark = i > 18 && i < 27;
    return { color, name, dark, hueIndex: i, sbIndex: -99 };
  });
  const after = lastColorList.map((item, i) => {
    const color = item.hex;
    const name = ['白色', '浅灰', '深灰', '黑色'][i];
    const dark = i === 2 || i === 3;
    return { color, name, dark, hueIndex: -1, sbIndex: i };
  });
  return [...normal, ...after].map((item, i) => ({ ...item, id: i + 1 }));
}
